import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {TabsModule} from 'ngx-bootstrap';
import {NgxPaginationModule} from 'ngx-pagination';

import {MyReportsComponent} from './myreports.component';
import {SessionLengthModule} from './session-length/session-length.module';
import {FeaturesDurationModule} from './features-duration/features-duration.module';
import {FeaturesNumberModule} from './features-number/features-number.module';
import {LeastUsedFeaturesModule} from './least-used-features/least-used-features.module';
import {UserSessionsModule} from './user-sessions/user-sessions.module';
import {DeniedFeaturesModule} from './denied-features/denied-features.module';
import {DeniedUsersModule} from './denied-users/denied-users.module';
import {DenialsDayModule} from './denials-day/denials-day.module';
import {DenialReasonsModule} from './denial-reasons/denial-reasons.module';
import {LicenseUsageModule} from './license-usage/license-usage.module';
import {BenchmarksModule} from './benchmarks/benchmarks.module';
import {UsersModule} from './users/users.module';
import {FeaturesModule} from './features/features.module';
import {ClosedSessionModule} from './closed-session/closed-session.module';
import {OpenSessionModule} from './open-session/open-session.module';
import {SummaryModule} from './summary/summary.module';
import {HistoryModule} from './history/history.module';
import {HistoryComponent} from './history/history.component';
import {DenialsModule} from './denials/denials.module';
import {HelperModule} from '../../helper/helper.module';
import {BarChartComponent} from './zoomView/bar-chart/bar-chart.component';
import {PieChartComponent} from './zoomView/pie-chart/pie-chart.component';
import {DygraphsComponent} from './zoomView/dygraphs/dygraphs.component';
import {ColumnChartComponent} from './zoomView/column-chart/column-chart.component';
import {UserComponent} from './zoomView/users/users.component';
import {ZoomErrorsComponent} from './zoomView/errors/errors.component';
import {FeatureComponent} from './zoomView/features/features.component';
import {CloseSessionsComponent} from './zoomView/close-sessions/close-sessions.component';
import {OpenSessionsComponent} from './zoomView/open-sessions/open-sessions.component';
import {DenialComponent} from './zoomView/denial/denial.component';
import {ErrorsModule} from './errors/errors.module';
import {VendorSpecificModule} from './vendor-specific/vendor-specific.module';
import {TooltipModule} from 'ngx-bootstrap';
import {PipeModule} from '../../services/pipe/pipe.module';
import {ChartsModule} from './charts/charts.module';

import {HttpClientModule, HttpClient} from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
  
}

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    TabsModule.forRoot(),
    NgxPaginationModule,
    SessionLengthModule,
    FeaturesDurationModule,
    OpenSessionModule,
    SummaryModule,
    DenialsDayModule,
    ChartsModule,
    ClosedSessionModule,
    DeniedFeaturesModule,
    DeniedUsersModule,
    FeaturesModule,
    FeaturesNumberModule,
    DenialReasonsModule,
    BenchmarksModule,
    LeastUsedFeaturesModule,
    UserSessionsModule,
    LicenseUsageModule,
    UsersModule,
    HistoryModule,
    HelperModule,
    DenialsModule,
    ErrorsModule,
    VendorSpecificModule,
    TooltipModule.forRoot(),
    PipeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  declarations: [
    MyReportsComponent,
    HistoryComponent,
    BarChartComponent,
    PieChartComponent,
    DygraphsComponent,
    ColumnChartComponent,
    UserComponent,
    FeatureComponent,
    CloseSessionsComponent,
    OpenSessionsComponent,
    DenialComponent,
    ZoomErrorsComponent
  ],
  entryComponents: [
    BarChartComponent,
    PieChartComponent,
    DygraphsComponent,
    ColumnChartComponent,
    UserComponent,
    FeatureComponent,
    CloseSessionsComponent,
    OpenSessionsComponent,
    DenialComponent,
    ZoomErrorsComponent
  ]
})
export class MyReportsModule {
}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/myreports.module.ts